import { useEffect, useState } from 'react';

/**
 * Tracks the OS reduced-motion preference.
 *
 * Starts false so the server and the first client render agree; the effect
 * corrects it immediately after mount. Every animated component checks this and
 * renders a static end-state rather than simply running faster.
 */
export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    const query = window.matchMedia?.('(prefers-reduced-motion: reduce)');
    if (!query) return;

    setReduced(query.matches);
    const onChange = (e: MediaQueryListEvent) => setReduced(e.matches);
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);

  return reduced;
}
